import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-fe/sails-constants';

/**
 * Check if tauschbonus can be selected for this device/saleschannel
 */
export function getIsTauschbonusEligible (): boolean {
    return window[ADDITIONAL_PAGE_OPTIONS]?.promos?.tauschbonus !== undefined;
}
